import React from 'react'

const CheckendBoxIcon = (props) => {
    const {color, width, height, pathColor} = props;
    return (
        <svg width={width} height={height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.5" width="20" height="20" rx="5" fill={color} />
            <path fillRule="evenodd" clipRule="evenodd" d="M14 8.7003L10.2608 12.3L9.01437 13.5L7.76797 12.3L7.77489 12.2933L6 10.5661L7.24674 9.3661L9.02129 11.0936L12.7536 7.5L14 8.7003Z" fill={pathColor} />
        </svg>
    )
}

export default CheckendBoxIcon